// extracted by mini-css-extract-plugin
export default {"business_name":"businessName_business_name__fU4yS","splitter":"businessName_splitter__coUcU"};